import { FillLayer } from "react-map-gl";
import { Theme } from "@mui/material/styles";

export const getAreaBaseLayer = (theme: Theme): FillLayer => {

  return {
    id: "area-base",
    type: "fill",
    "source-layer": "postal_area_test",
    maxzoom: 7,
    minzoom: 4,
    paint: {
      "fill-outline-color": "rgba(33,43,58,0.4)",
      "fill-color": [
        "case",
        ["==", ["feature-state", "score"], null],
        "#ECF3F4",
        [
          "interpolate",
          ["linear"],
          ["feature-state", "score"],
          0,
          theme.palette.gradient[0],
          0.1,
          theme.palette.gradient[1],
          0.2,
          theme.palette.gradient[2],
          0.3,
          theme.palette.gradient[3],
          0.4,
          theme.palette.gradient[4],
        ],
      ],
      "fill-opacity":
      [
        "case",
        ["==", ["feature-state", "score"], null],
        0,
        ["case", ["<", ["feature-state", "score"], 0], 0, 1],
      ],
    }
  }
}
